<template>
  <section class="space-y-2 p-4">
    <viewTitle title="业务管理 / 报表管理 / 木片打卡统计表" :showReturn="true">
      <template slot="return">
        <el-button @click="onExport" v-has="['c-mpReport-record-clockExport']" type="primary" size="small">导出</el-button>
      </template>
    </viewTitle>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="基地">
        <el-select class="w-40" clearable v-model="queryParam.base_id">
          <el-option
            v-for="item in com_list"
            :key="item.com_id"
            :label="item.com_name"
            :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="木片厂名称">
        <el-input
          clearable
          v-model="queryParam.chip_name"
          placeholder="请输入木片厂名称"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="物料描述">
        <el-input
          clearable
          v-model="queryParam.chip_type"
          placeholder="请输入物料描述"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="省">
        <el-input
          clearable
          v-model="queryParam.province"
          placeholder="请输入省"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="市">
        <el-input
          clearable
          v-model="queryParam.city"
          placeholder="请输入市"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="县">
        <el-input
          clearable
          v-model="queryParam.district"
          placeholder="请输入县"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="打卡时间">
        <el-date-picker class="!w-96" style="margin-bottom: 10px;" v-model="timeRange" type="daterange"
          align="right" unlink-panels range-separator="至" :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
          value-format="timestamp"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="refreshData" type="primary" size="small"
          >刷新数据</el-button
        >
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
    </c-table>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
export default {
  data() {
    return {
      columns: [
        { label: "基地", prop: "company_name" },
        { label: "打卡日期", prop: "clock_day" },
        { label: "月份", prop: "clock_month" },
        { label: "物料描述", prop: "chip_type" },
        { label: "供应商", prop: "supplier_name" },
        { label: "木片厂", prop: "chip_name" },
        { label: "省", prop: "province" },
        { label: "市", prop: "city" },
        { label: "县", prop: "district" },
        { label: "当天打卡车次", prop: "clock_num_day" },
        { 
          label: "较昨天打卡数量",
          prop: "clock_num_yesterday",
          formatData: row => {
            const today = row.clock_num_day || 0;
            const yesterday = row.clock_num_yesterday || 0;
            return today - yesterday;
          }
        },
        { 
          label: "当月累计打卡总数量", 
          prop: "clock_num_month"
        }
      ],
      exportDataEvent: params => {
        const { begin_time, end_time, ...otherParams } = params;
        return this.$common.http({
          url: "/api/queue/admin/booking_clock_report_export",
          data: {
            ...otherParams,
            begin_clock_time: begin_time,
            end_clock_time: end_time,
          },
          noLoading: true
        })
      },
      fetchDataEvent: params => {
        const { begin_time, end_time, ...otherParams } = params;
        return this.$common.http({
          url: "/api/queue/admin/booking_clock_report_list",
          data: {
            ...otherParams,
            begin_clock_time: begin_time,
            end_clock_time: end_time,
          }
        });
      },
    };
  },
  mixins: [initListMinxin]
};
</script>
<style lang="less" scoped></style>
